import React, { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function SmoothScroll({ children }) {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    // Expose globally so route-level helpers (e.g. ScrollToTop) can reset it
    if (typeof window !== "undefined") {
      window.__lenis = lenis;
    }

    // Keep GSAP ScrollTrigger in sync with Lenis-driven scroll position.
    // Without this, triggers placed in mid-page never fire because Lenis
    // animates the scroll position without dispatching native scroll events
    // that ScrollTrigger can see.
    lenis.on("scroll", ScrollTrigger.update);

    const tickerCb = (time) => {
      lenis.raf(time * 1000);
    };
    gsap.ticker.add(tickerCb);
    gsap.ticker.lagSmoothing(0);

    // Recompute trigger positions once content is laid out
    const refreshTimeout = setTimeout(() => ScrollTrigger.refresh(), 200);

    return () => {
      clearTimeout(refreshTimeout);
      gsap.ticker.remove(tickerCb);
      lenis.destroy();
      if (typeof window !== "undefined" && window.__lenis === lenis) {
        window.__lenis = null;
      }
    };
  }, []);

  return children;
}
